/**
 * 隐藏手机号码
 */
let formatPhone  = function(val){
  if(val) {
    val = val + "";
    return val.substring(0,3) + '****' + val.substring(val.length-4);
  }
}

/**
 * 隐藏身份证号码
 */
let formatIdcard  = function(val){
  if(val) {
    val = val + "";
    let data = val.replace(/^(.{3})(?:\d+)(.{4})$/, "$1*******$2");
    return data;
  }
}

export { formatPhone, formatIdcard}


// WEBPACK FOOTER //
// ./src/utils/filters.js